var map = {
	"./de/manifold_entry_direction.png": 894,
	"./en/manifold_entry_direction.png": 895,
	"./es/manifold_entry_direction.png": 896,
	"./fr/manifold_entry_direction.png": 897,
	"./frFR/manifold_entry_direction.png": 898
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1997;


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers ^\.\/.*\/manifold_entry_direction\.png$
// module id = 1997
// module chunks = 0